
import * as d3 from 'd3'
export default {

  methods: {

    popup_WorkOrder(selection, _d, _item) {

      let woCanvas = selection
      .append('g')
      .attr('id', `MODAL_WORKORDER`)
      .attr('transform', `translate(0.5, 30.5)`)

      woCanvas
      .append('image')
      .attr('xlink:href', this.HOST + `/WorkOrder/icons/WO_History.svg`)
      .attr('x', 5).attr('y', -27).attr('width', 100).attr('cursor', 'pointer').attr('opacity', 1)
      .on('mouseover', function() {d3.select(this).transition().duration(75).attr('opacity', .5)})
      .on('mouseout', function() {d3.select(this).transition().duration(250).attr('opacity', 1)})
      .on('click', ()=> {
        d3.select(`#MODAL_WORKORDER`).remove()
        this.popup_MenuItem(selection, _item)
      })

      let edit = selection
      .append('g')
      .attr('id', `BTN_EDIT`)
      .attr('transform', `translate(700, 5)`)
      .attr('cursor', 'pointer').attr('opacity', 1)
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', 1)
      })
      .on('click', ()=> {
        let request_ = {
          action: {
            type: 'direct',
            target: 'workorder',
            component: 'ServiceToDoList',
            id: _d.IDX,
            no: ''
          },
          filters: { 
          },
          iFilters: {
            filterString : '',
            inputFilter  : ''
          }
        }
        this.$emit('request-action', request_)

      })

       edit
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', 50).attr('height', 20)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)
      .attr('fill', `url(#${this.localId}_LightBlue_)`)
      .attr('opacity', .5) 
      
      edit
      .append('text')
      .attr('x', 25).attr('y', 14)
      .attr('font-size', 11).attr('text-anchor', 'middle')
      .attr('fill', '#000')
      .text(`Edit`)


      this.loadSvg(
        woCanvas, {
        x   : 0,
        y   : 0,
        url : this.HOST + `/WorkOrder/WorkOrder_r1.svg`
      }).then(() => {
        d3.selectAll('text').style('font-family', 'roboto')

        this.workorder.filter(f=> f.type=='txt').forEach(d=> {
          d3.select((`#${d.code}-name`)).style('font-style', 'italic')
        })

        let status = this.workorder.find(f=> f.status == _d.STATUS)
        d3.select(`#TimeBar`).attr('width', status ? status.ex : 0).style('fill', status.color)
        
        d3.select(`#${status.code}-title`).style('fill', '#000')
        d3.select(`#${status.code}-val`).style('fill', '#000')
        d3.select(`#${status.code}-circle`).style('r', 12.5).style('stroke-width', 2).style('stroke', status.color)
       
        let x = 163 + (330 * (_d.PROG)/100)
        if(_d.STATUS == 'Progress') d3.select(`#TimeBar`).attr('width', x)

        let proBox = woCanvas
        .append('g')
        .attr('transform', `translate(${x}, 0)`)

        proBox
        .append('image')
        .attr('xlink:href', this.HOST + `/WorkOrder/avatar/${_d.INCHARGE ? _d.INCHARGE : 'default'}.png`)
        .attr('x', 20).attr('y', 105).attr('width', 35)

        proBox
        .append('polygon')
        .attr('points', `70,155 0,155 0,140 70,140 80,147`)
        .attr('fill', status.color)
    
        this.gmx_Text(proBox, ``, 5, 150,  8, '#757575','start', '', 'Progress')
        this.gmx_Text(proBox, ``, 40, 150,  9, '#000','start', '', `(${_d.PROG}%)`)

        this.innerSvg_WorkOrder(woCanvas, _d)
        this.draw_Comments(woCanvas, _d)
      })

    },


    innerSvg_WorkOrder(selection, _d) {
      this.workorder.forEach(d=> {
        d3.select(`#${d.code}-val`).attr('text-anchor', d.align).text(_d[d.code])
        if(d.type == 'btn' && !_d[d.code]) {
          d3.select(`#${d.code}-rect`).attr('opacity', 0)
          d3.select(`#${d.code}-title`).attr('opacity', .3)
        }
        
        if(d.type == 'pro') {
          d3.select(`#PROG-title`).attr('text-anchor', d.align).text(`Progress(${_d.PROG})`)
          d3.select(`#PROG-rect`).attr('width', 360*(_d.PROG/100))
        }
      })
    },


    draw_Comments(selection, _d) {
      let _self = this
      let data = this.comments.filter(f=> f.WO == _d.IDX) 
      data.filter(f=> f.USER == 'JINKEE').forEach(d=> { d.USER = 'jinkee' })

      data.sort((a, b) => {
        const idx = a.IDX - b.IDX
        if (idx !== 0) return idx
        return a.PARENT - b.PARENT
      })
      
      let cmtCanvas = selection
      .append('g')
      .attr('transform', `translate(80, 240)`)

      let _y = 0
      data.filter(f=> f.PARENT == 0).forEach(d=> {

        let _x = 0
        draw_CommentReplay(cmtCanvas, d, _x) // -----> below

        data.filter(f=> f.PARENT == d.IDX).forEach(rep=> {
          _x += 40
          cmtCanvas
          .append('image')
          .attr('xlink:href', this.HOST + `/WorkOrder/icons/Reply.svg`)
          .attr('x', _x-60).attr('y', _y-5).attr('width', 15)

          draw_CommentReplay(cmtCanvas, rep, _x) // -----> below
        })

      })

      function draw_CommentReplay(selection, data, _x){
        selection
        .append('image')
        .attr('xlink:href', _self.HOST + `/WorkOrder/avatar/${data.USER}.png`)
        .attr('x', _x-40).attr('y', _y-10).attr('width', 30)


        selection
        .append('text')
        .attr('id', `NAME_${data.IDX}`)
        .attr('x', _x).attr('y', _y)
        .attr('font-size', 12).attr('fill', '#000').attr('font-weight', 410)
        .text(data.USER)

        _self.gmx_Text(selection, '', _x + _self.getNode(`#NAME_${data.IDX}`) + 10, _y,  9, '#bcbcbc','start', '', _self.gmx_changeDate('mmm', data.DATE))

        _y += 18
        selection
        .append('text')
        .attr('id', `CMT_${data.IDX}_${data.PARENT}`)
        .attr('y', _y)
        .selectAll('tspan')
        .data(data.CONTENT.split('|'))
        .enter()
        .append('tspan')
        .attr('x', _x)
        .attr('font-size', 11).attr('fill', '#333')
        .attr('dy', (d, i) => i === 0 ? 0 : '1.5em')
        .text(d => d)

        _y += _self.getNode(`#CMT_${data.IDX}_${data.PARENT}`, 'height') + 20
      }
    },


  }
}